import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useAuthUserRestaurant,
  useGetRestaurantTrackLocationsQuery,
} from '@durma-soft/gros-sdk';

import { Alert } from '@/components/shared/alert';
import { Spinner } from '@/components/shared/spinner';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/shared/shadcn-ui/select';

import {
  CompanyLocationFormData,
  SingleCompanyLocationFormData,
} from '@/types/companies';

interface Props {
  formData: CompanyLocationFormData | SingleCompanyLocationFormData;
  setRestaurantTrackLocationId: (id: number | null) => void;
}

export const RestaurantTrackLocationsForCreate = ({
  formData,
  setRestaurantTrackLocationId,
}: Props) => {
  const uid = useId();
  const { t } = useTranslation();
  const restaurant = useAuthUserRestaurant();

  const { data: trackLocations, isLoading } =
    useGetRestaurantTrackLocationsQuery({
      restaurant_id: restaurant.id,
    });

  if (isLoading) return <Spinner />;

  if (!isLoading && trackLocations?.length === 0)
    return (
      <Alert
        variant="destructive"
        title={t('common.no-results')}
        description={t('track-location.no-results-description')}
      />
    );

  return (
    <Select
      value={
        formData.restaurant_track_location_id
          ? `${formData.restaurant_track_location_id}`
          : undefined
      }
      onValueChange={(e) => {
        if (formData.location_type === 'restaurant') {
          setRestaurantTrackLocationId(+e);
        } else {
          setRestaurantTrackLocationId(null);
        }
      }}
    >
      <SelectTrigger id={uid + '-menu-type'}>
        <SelectValue placeholder={t('track-location.choose')} />
      </SelectTrigger>
      <SelectContent>
        {trackLocations &&
          trackLocations.map(({ id, name }) => (
            <SelectItem key={id} value={`${id}`}>
              {name}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};
